module.exports = __webpack_public_path__ + "img/edit-company.6591100e.svg";